(function () {
    let mix = function({color_1 = 'ffffff', color_2, weight}) {
        function d2h(d) { return d.toString(16); }  // convert a decimal value to hex
        function h2d(h) { return parseInt(h, 16); } // convert a hex value to decimal 
      
        weight = (typeof(weight) !== 'undefined') ? weight : 50; // set the weight to 50%, if that argument is omitted
      
        var color = "#";
      
        for(var i = 0; i <= 5; i += 2) { // loop through each of the 3 hex pairs—red, green, and blue
          var v1 = h2d(color_1.substr(i, 2)), // extract the current pairs
              v2 = h2d(color_2.substr(i, 2)),
              
              // combine the current pairs from each source color, according to the specified weight
              val = d2h(Math.floor(v2 + (v1 - v2) * (weight / 100.0))); 
      
          while(val.length < 2) { val = '0' + val; } // prepend a '0' if val results in a single digit
          
          color += val; // concatenate val to our new color string
        }
          
        return color; // PROFIT!
      };
    angular.module('ui2.0Service').factory('cdrDataTransformService', ['$http', '$rootScope', '$compile', '$window', function ($http, $rootScope, $compile, $window) {

        return {
            getPostObjForListData: getPostObjForListData,
            cdrTransform: cdrTransform,
            colorMixFn: mix
        }

        function getPostObjForListData(entityTypeId) {
            const postObjForListData = {
                filterMap: {
                    entityTypeId,
                    offset: 0,
                    size: 20,
                    orderByColumnName: "id",
                    orderDirection: "asc",
                    filterJson: {},
                    customFilter: {
                        contractClauseTabFilter: {
                            contractClauseTabFilter: true // Set to true to filter out docx file
                        }
                    }
                }
            };
            return postObjForListData;
        }
        function cdrTransform(columns, listData, hiddenColumnsName, primaryKey, shouldPersistKey) {
            if (angular.isDefined(columns) && angular.isDefined(listData)) {
                let transformedData = {};
                listData.forEach(function (data, i) {
                    let rowObjData = {}, id, contentControlId, flowDownClause, showFlowDown = true;
                    Object.keys(data).forEach(function (key) {
                        let doesColumnExists = columns.find(col => col.queryName == data[key].columnName);
                        if(!doesColumnExists){
                           return;
                        }
                        var cellData = {
                            'colName': data[key]['columnName'],
                            'value': (data[key]['columnName'] == 'reviewTaskDetail') ? JSON.parse(data[key]['value']) : data[key]['value'],
                            'displayFormat': columns.find(col => col.queryName == data[key].columnName).displayFormat
                        }
                        if(cellData.colName == 'deviationStatus'){
                            let statusCode = cellData.value;
                            cellData = rowObjData['clauseVersion'];
                            cellData.statusCode = statusCode;
                        }
                        if(cellData.colName == 'reviewEditable' && rowObjData?.reviewTaskDetail?.value){
                            let reviewEditable = cellData.value;
                            cellData = rowObjData['reviewTaskDetail'];
                            cellData.reviewEditable = reviewEditable;
                        }
                        if(cellData.colName == "contentControlId" && cellData.value){
                            contentControlId = cellData.value;
                            //to show flow-Down icon in case when value is not starting with queryString 
                            const queryString="UNCATEGORISED"
                            if(cellData?.value.indexOf(queryString) !== -1){
                                showFlowDown=false;
                            }

                        }
                        if(cellData.colName == 'companyPosition' && cellData.value?.indexOf(':;') > -1) {
                            const valArr = cellData.value.split(':;');
                            if (valArr[1]?.split('#')[1]) {
                                valArr[1] = '#'+mix({"color_2": valArr[1].split('#')[1], "color_1": 'ffffff', weight: 85});
                                cellData.value = valArr.join(':;');
                            }
                        }
                        if (cellData.colName == "flowDownClause") {
                            flowDownClause = cellData && cellData.value == 'true' ? true : false;
                        }
                        // if(cellData.colName == 'reviewTaskDetail'){
                        //     cellData.value = {"currentTask":{"id":"5e13386159e13649220e2e94", "taskId":1001, "clientId":0, "initialTask":true, "finalTask":false, "labelId":29920, "nextTaskIds":[{"id":null, "taskId":1002, "clientId":0, "initialTask":false, "finalTask":true, "labelId":29921, "nextTaskIds":null, "taskName":"Review Cancelled", "taskButtonName":"Review Cancelled", "editAllowed":null}, {"id":null, "taskId":1003, "clientId":0, "initialTask":false, "finalTask":true, "labelId":29922, "nextTaskIds":null, "taskName":"Review Completed", "taskButtonName":"Review Completed", "editAllowed":null}], "taskName":"Review Processed", "taskButtonName":"Review Processed", "editAllowed":true},"performedBy":"Chinmaya Nayak RC- replica", "performedOn":"Mon Jan 06 14:34:32 EST 2020", "modified":null, "modifiedText":null};
                        // }
                        if ((data[key]['columnName']) == primaryKey) {
                            id = data[key]['value'];
                        }
                        if(angular.isDefined(hiddenColumnsName)) {
                            if (!(hiddenColumnsName.indexOf(cellData.colName) > -1) || ['clauseCategoryId', 'groupId', 'documentFileId'].includes(cellData.colName)) {
                                rowObjData[cellData.colName] = cellData;
                            }
                        }
                    });

                    if (!id) {
                        id = i;
                    }
                    transformedData[id] = {
                        'myRowData': rowObjData,
                        'childData': {}
                    }
                    if(shouldPersistKey){
                        transformedData[id]["id"] =  id;
                    }
                    if(contentControlId){
                        transformedData[id]['contentControlId'] = contentControlId;
                    }
                    if (flowDownClause != null) {
                        transformedData[id]['flowdownclause'] = flowDownClause;
                    }
                    // setting flag to show flow-down icon
                    transformedData[id]['showFlowDown'] = showFlowDown;
                });
                return transformedData;
            }
        }
    }]);

    angular.module('ui2.0Service').service('cdrDetailDataTransformService', ['$http', '$rootScope', '$compile', '$window', 'entityFactory', function ($http, $rootScope, $compile, $window, entityFactory) {
        this.cdrTransform = function(columns, listData, hiddenColumnsName, primaryKey, shouldPersistKey) {
            if (angular.isDefined(columns) && angular.isDefined(listData)) {
                let transformedData = {};
                listData.forEach(function (data, i) {
                    let rowObjData = {}, id;
                    Object.keys(data).forEach(function (key) {
                        var cellData = {
                            'colName': data[key]['columnName'],
                            'value': data[key]['value'],
                            'displayFormat': columns.find(col => col.queryName == data[key].columnName).displayFormat
                        }
                        if(cellData.colName == 'deviationStatus'){
                            let statusCode = cellData.value;
                            cellData = rowObjData['clauseVersion'];
                            cellData.statusCode = statusCode;
                        }
                        if ((data[key]['columnName']) == primaryKey) {
                            id = data[key]['value'];
                        }
                        if(angular.isDefined(hiddenColumnsName)) {
                            if (!(hiddenColumnsName.indexOf(cellData.colName) > -1)) {
                                rowObjData[cellData.colName] = cellData;
                            }
                        }
                    });

                    if (!id) {
                        id = i;
                    }
                    transformedData[id] = {
                        'myRowData': rowObjData,
                        'childData': {}
                    }
                    if(shouldPersistKey){
                        transformedData[id]["id"] =  id;
                    }
                });
                return transformedData;
            }
        }

        this.transformListData = function(listData, origMetaData) {
            const visColToIdMapper = {},
                visibleColsArray = ["docversionhidden", "version", "documentname", "documentstatus"],
                visCols = origMetaData.columns.filter(col => {
                    return visibleColsArray.indexOf(col.queryName) > -1;
                }),
                visColsCount = visCols.length;
                let finalListData = [];

            // If visible columns, map queryName with id
            if (visCols) {
                visCols.forEach(function (col) {
                    visColToIdMapper[col.queryName] = col.id;
                });
            }

            // Go through each visible column from origMetaData
            for (let i = 0; i < visColsCount; i++) {
                let k = i,
                    id = visCols[i].id,
                    formatter = $.parseJSON(visCols[i].displayFormat);

                // Iterate over each row
                if (!SirionUtils.isEmpty(listData)) {
                    for (let j = 0; j < listData.length; j++) {
                        if (listData[j][id] != undefined) {
                            let val = "";
                            if (formatter.hideColumn && visCols[i].queryName == "docversionhidden") {
                                let splitParams = listData[j][id].value.split(":;"),
                                    document = {
                                        'docId': parseInt(splitParams[0]),
                                        'isParent': splitParams[2],
                                        'order': parseInt(splitParams[1]),
                                        'total': parseInt(splitParams[3])
                                    }
                                val = document;
                            }
                            if (formatter != null && formatter.type != undefined) {
                                let formatType = formatter.type
                                if (visCols[i].type == "ATTACHMENT") {
                                    let splitParams = listData[j][id].value.split(':;'),
                                        link = appName + "/download/communicationdocument?id=" + splitParams[0] + "&entityTypeId=78&entityType.id=" + splitParams[3] + "&fileId=" + splitParams[4],
                                        document = {
                                            'name': splitParams[1],
                                            'link': link,
                                            'format': splitParams[2],
                                            'fileId': splitParams[4]
                                        };
                                    val = document;
                                }
                                else if (formatType == "docVersion") {
                                    val = listData[j][id].value;
                                }
                                else if (formatType == "documentStatus" || formatter.displayType == "dropdown") {
                                    var dropdownData;
                                    if (origMetaData.draftMetadata && origMetaData.draftMetadata.templateTypeList) {
                                        dropdownData = origMetaData.draftMetadata.templateTypeList;
                                        formatter.readOnly = true;
                                    }
                                    val = entityFactory.transform.customDropdown(listData[j][id].value, formatter, this, origMetaData.id, dropdownData);
                                }
                            }
                            finalListData[j][visCols[i].queryName] = val;
                        }
                    }
                }
            }
            return finalListData;
        }
    }]);
})();